module.exports = __webpack_public_path__ + "img/3.8e11a244.png";